export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-all-400-normal.woff?e4678b5590bfeb8fdbb1cff1145373c1";